<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="app-toolbar" color="primary"> </mat-toolbar>

<div class="main-content">
  <section class="container" *ngIf="status$ | async as status">
    <h2 translate>User.ChangePassword</h2>

    <p *ngIf="status === PasswordChangeStatus.ChangeFailed">
      <mat-error>{{ error$ | async | translate }}</mat-error>
    </p>

    <div *ngIf="status === PasswordChangeStatus.Changing" class="cf-flex-column cf-align-items-center cf-gap-24">
      <mat-spinner></mat-spinner>
      <p>{{ 'User.ChangingPassword' | translate }}</p>
    </div>

    <div *ngIf="status === PasswordChangeStatus.Changed">
      <p>{{ 'User.PasswordChanged' | translate }}</p>
      <div class="form-button">
        <a routerLink="/projects">
          <button type="button" mat-stroked-button>{{ 'UI.Common.GoToProjects' | translate }}</button>
        </a>
      </div>
    </div>

    <form *ngIf="status === PasswordChangeStatus.InputForm || status === PasswordChangeStatus.ChangeFailed" novalidate (submit)="save()">
      <app-password-input
        [inputControl]="form.controls.oldPassword"
        labelTextId="User.OldPassword"
        subscriptSizing="fixed"
        [required]="true"
      ></app-password-input>

      <app-password-input
        [inputControl]="form.controls.newPassword"
        labelTextId="User.NewPassword"
        subscriptSizing="dynamic"
        [required]="true"
        [hint]="'User.Password.ToolTip' | translate"
      ></app-password-input>

      <app-password-input
        [inputControl]="form.controls.confirmPassword"
        labelTextId="User.ConfirmPassword"
        subscriptSizing="dynamic"
        [required]="true"
      ></app-password-input>

      <mat-error
        class="passwords-not-match"
        *ngIf="form.controls.confirmPassword.dirty && form.errors && form.errors['passwordNoMatch']"
        translate
      >
        UI.Auth.PasswordsDoNotMatch
      </mat-error>

      <div class="cf-flex-row cf-gap-24 submit-button">
        <div class="form-button">
          <button type="submit" [disabled]="form.invalid" mat-flat-button color="primary">{{ 'UI.Common.Action.Save' | translate }}</button>
        </div>

        <div class="form-button">
          <a routerLink="/projects">
            <button type="button" mat-stroked-button>{{ 'UI.Common.GoToProjects' | translate }}</button>
          </a>
        </div>
      </div>
    </form>
  </section>
</div>
